export const MODULE = {
  careconne: 'CARECONNE',
};
